import SPXOptionsCalls from "./components/SPXOptionsCalls";
import OptionsPrediction from "./pages/ai/OptionsPrediction";
import AIAnalysis from "./pages/ai/AIAnalysis";
import FuturePrediction from "./pages/ai/FuturePrediction";
import StockPrediction from "./pages/StockPrediction";
import AITrading from "./pages/AITrading";
import PaymentHistory from "./pages/PaymentHistory";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { AuthProvider } from "./lib/auth";
import Analytics from "./pages/Analytics";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Plans from "./pages/Plans";
import Dashboard from "./pages/Dashboard";
import Markets from "./pages/Markets";
import Portfolio from "./pages/Portfolio";
import Watchlist from "./pages/Watchlist";
import Admin from "./pages/Admin";
import PaymentSuccess from "./pages/PaymentSuccess";

import DashboardLayout from "./components/DashboardLayout";

// Full page redirect to a URL outside this React app (e.g. WordPress under /shop)
function ExternalRedirect({ to }) {
    useEffect(() => {
        window.location.replace(to);
    }, [to]);
    return null;
}

function App() {
    return (
        <PayPalScriptProvider
            options={{
                "client-id": "ASquYrn1012dci9lciL6HO4no7Lrw7tze4JMH8db8TSExQu8ouDSv0CphpXLqZQvygh2YClwUoiWO4A9",
                currency: "USD",
                intent: "subscription",
                vault: true,
            }}
        >
            <AuthProvider>
                <BrowserRouter>
                    <Routes>

                        {/* Public Routes */}
                        <Route path="/" element={<Landing />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/signup" element={<Signup />} />
                        <Route path="/admin" element={<Admin />} />

                        {/* Dashboard membership plans */}
                        <Route
                            path="/dashboard/plans"
                            element={<Plans />}
                        />

                        {/* Dashboard */}
                        <Route element={<DashboardLayout />}>
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/dashboard/markets" element={<Markets />} />
                            <Route
  path="/dashboard/spx-options"
  element={<SPXOptionsCalls />}
/>
                            <Route path="/dashboard/portfolio" element={<Portfolio />} />
                            <Route path="/dashboard/watchlist" element={<Watchlist />} />
                            <Route path="/dashboard/payment-history"  element={<PaymentHistory />}/>
                            <Route path="/dashboard/analytics" element={<Analytics />} />
                            <Route path="/dashboard/ai"  element={<AITrading />} />
                            <Route path="/dashboard/ai/stocks" element={<StockPrediction />} />
                            <Route path="/dashboard/ai/options" element={<OptionsPrediction />} />
                            <Route path="/dashboard/ai/analysis" element={<AIAnalysis />} />
                            <Route path="/dashboard/ai/future" element={<FuturePrediction />} />
                        </Route>

                        {/* Direct Routes */}
                        <Route path="/plans" element={<Plans />} />
                        <Route path="/markets" element={<Markets />} />
                        <Route path="/portfolio" element={<Portfolio />} />
                        <Route path="/watchlist" element={<Watchlist />} />
                        <Route path="/analytics" element={<Analytics />} />
                        <Route path="/payment-success" element={<PaymentSuccess />} />

                    </Routes>

                </BrowserRouter>
            </AuthProvider>
        </PayPalScriptProvider>
    );
}

export default App;